module.exports = __webpack_public_path__ + "static/media/llp-home-banner-mobile.936153b7.webp";